import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { Cookie } from 'ng2-cookies/ng2-cookies';

@Injectable()
export class MapsSidebarService {

  API_URL: string = '';
  environmentName: string = '';
  userTokenApiCall: string = '';

  mapInterval: any;

  mapLoadedChangeSource = new BehaviorSubject<boolean>(false);
  mapLoadedChangeStream = this.mapLoadedChangeSource.asObservable();

  //Retailers
  showRetailerFilter : boolean = false;
  viewportAZRetailers: any[] = [];
  retailerCategories: any[] = [];
  randomRetailers: any[] = [];
  previousBounds: any;
  azRetailerPageNumber: number;
  retailerSearchValue: string = '';
  viewportAZRetailersAllFetched: boolean = false;

  retailerFilterActiveSource = new BehaviorSubject<boolean>(false);
  retailerFilterActiveStream = this.retailerFilterActiveSource.asObservable();

  randomRetailerSource = new BehaviorSubject<boolean>(false);
  randomRetailerStream = this.randomRetailerSource.asObservable();

  //Properties
  showPropertyFilter : boolean = false;
  propertyFilterActiveSource = new BehaviorSubject<boolean>(false);
  propertyFilterActiveStream = this.propertyFilterActiveSource.asObservable();

  //Demographics
  showDemographicFilter : boolean = false;
  demographicFilterActiveSource = new BehaviorSubject<boolean>(false);
  demographicFilterActiveStream = this.demographicFilterActiveSource.asObservable();

  //Overlays
  showOverlayFilter : boolean = false;
  overlayFilterActiveSource = new BehaviorSubject<boolean>(false);
  overlayFilterActiveStream = this.overlayFilterActiveSource.asObservable();

  //Places
  showPlaceFilter : boolean = false;
  placeFilterActiveSource = new BehaviorSubject<boolean>(false);
  placeFilterActiveStream = this.placeFilterActiveSource.asObservable();

  //Measure
  showMeasureFilter : boolean = false;
  measaureFilterActiveSource = new BehaviorSubject<boolean>(false);
  measaureFilterActiveStream = this.measaureFilterActiveSource.asObservable();

  //Hidden Items
  showHiddenFilter : boolean = false;
  hiddenFilterActiveSource = new BehaviorSubject<boolean>(false);
  hiddenFilterActiveStream = this.hiddenFilterActiveSource.asObservable();

  constructor(public httpClient: HttpClient) { }

  checkIfMapLoaded() {
    let w = (<any>window);
    if(w.mmap && w.mmap.googleMapFullyLoaded) {
      this.mapLoadedChangeSource.next(true);
    } else {
      w.Events.subscribe('googleMapFullyLoaded', ()=>{
        this.mapLoadedChangeSource.next(true);
      });
    }
  }

  constructGeoJsonPolygon(NEBounds, SWBounds) {
    return {
      type: 'Polygon',
      srid:null,
      coordinates: [[
        [NEBounds.toJSON().lng, NEBounds.toJSON().lat],
        [SWBounds.toJSON().lng, NEBounds.toJSON().lat],
        [SWBounds.toJSON().lng, SWBounds.toJSON().lat],
        [NEBounds.toJSON().lng, SWBounds.toJSON().lat],
        [NEBounds.toJSON().lng, NEBounds.toJSON().lat]
      ]]
    };
  }

  //Retailers
  getRetailer(within, pageNumber, recordsPerPage, name?) {
    let w = (<any>window);
    return this.httpClient.get(this.API_URL+'/rdx/retailer?'+
      'within='+encodeURIComponent(JSON.stringify(within))+'&pageNumber='+ pageNumber +
      '&recordsPerPage=' + recordsPerPage + (name ? ('&name='+ encodeURIComponent(name)) : ''))
      .map((res) => {
        return res;
      });
  }

  getRetailerCategory() {
    let w = (<any>window);
    return this.httpClient.get(this.API_URL+'/rdx/retailer-category')
      .map((res) => {
        return res;
      });
  }

  getRetailerByCategoryIds(within, categoryIds) {
    let w = (<any>window);
    return this.httpClient.get(this.API_URL+'/rdx/retailer/by-category?'+
      'within='+encodeURIComponent(JSON.stringify(within))+
      '&categoryIds='+ categoryIds)
      .map((res) => {
        return res;
      });
  }

  fetchRandomRetailers(number) {
    let w = (<any>window),
        bounds = (<any>window).map.getBounds(),
        NEBounds = bounds.getNorthEast(),
        SWBounds = bounds.getSouthWest();

    return this.httpClient.get(this.API_URL+'/rdx/retailer/location/random?number=' + number + '&'+
      'within='+encodeURIComponent(JSON.stringify(this.constructGeoJsonPolygon(NEBounds,SWBounds))))
      .map((res) => {
        return res;
      });
  }

  fetchRetailerData() {
    let w = (<any>window);
    let bounds = w.map.getBounds(),
        extendedBounds = w.getExtendedBounds(),
        NEBounds = extendedBounds.NEBounds,
        SWBounds = extendedBounds.SWBounds;
    if(!this.previousBounds || !this.previousBounds.equals(bounds)) {
      this.azRetailerPageNumber = 1;
      this.viewportAZRetailersAllFetched = false;
      this.azRetailerApiCall();
      this.retailerCategoryApiCall();
      this.previousBounds = bounds;
    }
  }

  retailerCategoryApiCall() {
    let w = (<any>window);
    this.getRetailerCategory()
    .subscribe((response: any)=>{
      this.retailerCategories = response;
      w.Events.publish('fetchOpenCategoryRetailers');
      w.Events.publish('detectChanges');
    }, (error)=>{
      throw error;
    });
  }

  azRetailerApiCall(paginate?) {
    let w = (<any>window);
    let bounds = w.map.getBounds(),
        NEBounds = bounds.getNorthEast(),
        SWBounds = bounds.getSouthWest(),
        recordsPerPage = 30;
    this.getRetailer(this.constructGeoJsonPolygon(NEBounds,SWBounds), this.azRetailerPageNumber, recordsPerPage, this.retailerSearchValue)
    .subscribe((response: any)=>{
      this.viewportAZRetailers = paginate ? this.viewportAZRetailers.concat(response) : response;
      (response.length === recordsPerPage) ? this.azRetailerPageNumber++ : (this.viewportAZRetailersAllFetched = true);
      w.Events.publish('updateRecentlySelectedRetailers');
      w.Events.publish('detectChanges');
    }, (error)=>{
      throw error;
    });
  }

  retailerByCategoryIdsApiCall(categoryIds, toggleCategoryRetailersData?) {
    let w = (<any>window);
    let bounds = w.map.getBounds(),
        extendedBounds = w.getExtendedBounds(),
        NEBounds = bounds.getNorthEast(),
        SWBounds = bounds.getSouthWest();
    this.getRetailerByCategoryIds(this.constructGeoJsonPolygon(NEBounds,SWBounds), categoryIds)
    .subscribe((response: any)=>{
      if(response) {
        for(let i = 0; i < response.length; i++) {
          let category = this.retailerCategories.find((obj)=>{
            return obj.categoryId === response[i].categoryId;
          });
          category && (category.retailers = response[i].retailers);
        }
        if(toggleCategoryRetailersData) {
          toggleCategoryRetailersData.category = this.retailerCategories.find((obj)=>{
            return obj.categoryId === toggleCategoryRetailersData.category.categoryId;
          });
          w.Events.publish('toggleCategoryRetailers', toggleCategoryRetailersData);
        }
      }
      w.Events.publish('detectChanges');
    }, (error)=>{
      throw error;
    });
  }

  paginateRetailerLayers(isAzSection) {
    if(isAzSection && !this.viewportAZRetailersAllFetched) {
      this.azRetailerApiCall(true);
    }
  }

  getLoggedInUser() {
    return this.httpClient.get(
      this.API_URL + this.userTokenApiCall
    )
    .map((res) => {
      return res;
    });
  }

  isUserLoggedIn() {
    return (Cookie.get('propertycapsule-' + this.environmentName + '.rememberMe') ? true : false) || !!Cookie.get('propertycapsule-' + this.environmentName + '.loggedIn');
  }

  getOrganizationDetails(customerId) {
    return this.httpClient.get(
      this.API_URL + '/organization/'+ customerId 
    )
    .map((res) => {
      return res;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/maps-sidebar/maps-sidebar.service.ts